(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["texbrite-category-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('texbrite-type-filter')) {
    customElements.define('texbrite-type-filter', class extends HTMLElement {
      connectedCallback() {
        this.onLinkClick = (event) => {
          const link = event.target.closest('a[data-product-type-link]');
          if (!link || !this.contains(link)) return;
          const target = new URL(link.getAttribute('href'), window.location.origin);
          target.search = '';
          const current = new URL(window.location.href);
          for (const [name, value] of current.searchParams) {
            if (name === 'sort_by' || name.startsWith('filter.') || name === 'preview_theme_id') {
              target.searchParams.append(name, value);
            }
          }
          link.href = target.toString();
        };
        this.onKeyDown = (event) => {
          if (event.key !== 'Escape') return;
          const disclosure = this.querySelector('details');
          if (disclosure?.open) {
            disclosure.open = false;
            disclosure.querySelector('summary').focus();
          }
        };
        this.addEventListener('click', this.onLinkClick);
        this.addEventListener('keydown', this.onKeyDown);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onLinkClick);
        this.removeEventListener('keydown', this.onKeyDown);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["texbrite-quick-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('texbrite-quick-order')) {
    customElements.define('texbrite-quick-order', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.copy = JSON.parse(this.querySelector('[data-qo-copy]').textContent);
        this.initialProducts = JSON.parse(this.querySelector('[data-qo-products]').textContent);
        this.selection = new Map();
        this.form = this.querySelector('[data-qo-search]');
        this.searchInput = this.form.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-qo-results]');
        this.searchStatus = this.querySelector('[data-qo-search-status]');
        this.feedback = this.querySelector('[data-qo-feedback]');
        this.cartButton = this.querySelector('[data-qo-add-cart]');
        this.cartButtonLabel = this.cartButton.textContent;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
        this.setupCustomerLookup();
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          clearTimeout(this.timer);
          this.search();
        });
        this.searchInput.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.controller?.abort();
          this.timer = setTimeout(() => this.search(), 300);
        });
        this.cartButton.addEventListener('click', () => this.addToCart());
        window.addEventListener('pageshow', event => {
          if (event.persisted && this.submitted) {
            this.busy = false;
            this.submitted = false;
            this.selection.clear();
            this.cartButton.textContent = this.cartButtonLabel;
            this.renderList();
            this.announce('');
            this.search();
          }
        });
        this.querySelector('[data-qo-interface]').hidden = false;
        document.title = this.copy.title + ' | ' + this.dataset.shopName;
        this.renderProducts(this.initialProducts, '');
        this.renderList();
        const query = new URL(location.href).searchParams.get('q');
        if (query) {
          this.searchInput.value = query.slice(0, 120);
          this.search();
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.customerLookupToken = (this.customerLookupToken || 0) + 1;
      }
      setupCustomerLookup() {
        this.customer = null;
        this.customerPage = 0;
        this.customerLookupToken = 0;
        this.customerSelections = new Map([['', this.selection]]);
        this.customerProducts = new Map();
        this.customerInput = this.querySelector('[data-qo-customer-input]');
        this.customerButton = this.querySelector('[data-qo-find-customer]');
        this.customerMatches = this.querySelector('[data-qo-customer-matches]');
        this.customerStatus = this.querySelector('[data-qo-customer-status]');
        this.customerInput.value = '';
        this.customerButton.disabled = true;
        this.querySelector('[data-qo-customer-active]').hidden = true;
        this.customerInput.addEventListener('input', () => {
          this.customerLookupToken++;
          this.hideCustomerMatches();
          this.customerStatus.textContent = '';
          this.customerButton.disabled = this.normalizeCustomer(this.customerInput.value).length < 4;
          if (this.customer) this.clearCustomer(false);
        });
        this.customerInput.addEventListener('keydown', event => {
          if (event.key === 'Enter' && !event.isComposing) {
            event.preventDefault();
            event.stopPropagation();
            this.findCustomer();
          }
          if (event.key === 'Escape') this.hideCustomerMatches();
        });
        this.querySelector('[data-qo-customer-form]').addEventListener('submit', event => {
          event.preventDefault();
          this.findCustomer();
        });
        this.customerButton.addEventListener('click', () => this.findCustomer());
        this.querySelector('[data-qo-clear-customer]').addEventListener('click', () => this.clearCustomer(true));
        this.querySelector('[data-qo-history-view]').addEventListener('change', () => {
          this.customerPage = 0;
          this.renderCustomerProducts();
        });
        this.querySelector('[data-qo-history-prev]').addEventListener('click', () => {
          this.customerPage = Math.max(0, this.customerPage - 1);
          this.renderCustomerProducts();
        });
        this.querySelector('[data-qo-history-next]').addEventListener('click', () => {
          this.customerPage++;
          this.renderCustomerProducts();
        });
      }
      normalizeCustomer(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
      hideCustomerMatches() {
        this.customerMatches.replaceChildren();
        this.customerMatches.hidden = true;
      }
      async findCustomer() {
        if (this.busy || this.cartUncertain) return;
        const query = this.normalizeCustomer(this.customerInput.value);
        const token = ++this.customerLookupToken;
        this.hideCustomerMatches();
        if (query.length < 4) {
          this.customerStatus.textContent = this.copy.customer_minimum;
          return;
        }
        this.customerStatus.textContent = this.copy.customer_loading;
        try {
          if (!this.customerData) {
            const response = await fetch(this.dataset.customersUrl, {credentials:'omit'});
            if (!response.ok) throw new Error('Customer data unavailable');
            const data = await response.json();
            if (!Array.isArray(data.customers)) throw new Error('Invalid customer data');
            if (data.version === 2 && !Array.isArray(data.products)) throw new Error('Invalid product data');
            this.customerData = data.customers.map(customer => {
              if (!Array.isArray(customer.items)) throw new Error('Invalid customer items');
              const items = customer.items.map(item => {
                if (data.version === 2 && (!Number.isInteger(item) || item < 0)) throw new Error('Invalid product reference');
                const product = data.version === 2 ? data.products[item] : item;
                if (!product || typeof product.sku !== 'string' || typeof product.title !== 'string') throw new Error('Invalid product record');
                return product;
              });
              return {...customer, items};
            });
          }
          if (token !== this.customerLookupToken || query !== this.normalizeCustomer(this.customerInput.value)) return;
          const matches = this.customerData.filter(customer => this.normalizeCustomer(customer.name).includes(query) || this.normalizeCustomer(customer.account).includes(query));
          this.customerStatus.textContent = matches.length ? '' : this.copy.customer_not_found;
          if (matches.length === 1) {
            this.chooseCustomer(matches[0]);
          } else if (matches.length > 1) {
            matches.forEach(customer => {
              const button = this.node('button', 'qo__button', customer.name);
              button.type = 'button';
              button.addEventListener('click', () => this.chooseCustomer(customer));
              this.customerMatches.append(button);
            });
            this.customerMatches.hidden = false;
          }
        } catch (error) {
          if (token === this.customerLookupToken) this.customerStatus.textContent = this.copy.customer_error;
        }
      }
      chooseCustomer(customer) {
        if (this.busy || this.cartUncertain || this.normalizeCustomer(this.customerInput.value).length < 4) return;
        clearTimeout(this.timer);
        this.controller?.abort();
        this.customerLookupToken++;
        this.customer = customer;
        this.customerPage = 0;
        this.customerInput.value = customer.name;
        this.customerStatus.textContent = '';
        this.hideCustomerMatches();
        if (!this.customerSelections.has(customer.account)) this.customerSelections.set(customer.account, new Map());
        this.selection = this.customerSelections.get(customer.account);
        this.searchInput.value = '';
        this.querySelector('[data-qo-history-view]').value = 'matched';
        this.querySelector('[data-qo-history-filter]').hidden = false;
        this.querySelector('[data-qo-customer-active]').hidden = false;
        this.querySelector('[data-qo-customer-name]').textContent = customer.name;
        this.querySelector('[data-qo-customer-count]').textContent = this.message('customer_history_count', {count:customer.items.length});
        this.renderList();
        this.announce('');
        this.renderCustomerProducts();
      }
      clearCustomer(resetInput) {
        if (this.busy || this.cartUncertain) return;
        clearTimeout(this.timer);
        this.controller?.abort();
        this.customerLookupToken++;
        this.customer = null;
        this.customerPage = 0;
        this.selection = this.customerSelections.get('');
        this.hideCustomerMatches();
        this.customerStatus.textContent = '';
        if (resetInput) {
          this.customerInput.value = '';
          this.customerButton.disabled = true;
        }
        this.querySelector('[data-qo-customer-active]').hidden = true;
        this.querySelector('[data-qo-customer-name]').textContent = '';
        this.querySelector('[data-qo-customer-count]').textContent = '';
        this.querySelector('[data-qo-history-filter]').hidden = true;
        this.querySelector('[data-qo-history-pages]').hidden = true;
        this.querySelector('[data-qo-heading]').textContent = this.copy.popular;
        this.searchInput.value = '';
        this.searchStatus.textContent = '';
        this.results.removeAttribute('aria-busy');
        this.renderProducts(this.initialProducts, '');
        this.renderList();
        this.announce('');
      }
      pendingCustomerProduct(item, unavailable = false) {
        return {id:'history-' + item.sku, title:item.title, url:this.dataset.contactUrl, image:null, variants:[], reorderPending:unavailable ? this.copy.customer_unavailable : item.status === 'conflict' ? this.copy.customer_conflict : this.copy.customer_unmatched, historyDetail:[item.size, item.sku].filter(Boolean).join(' · ')};
      }
      async currentCustomerProduct(item, signal) {
        if (!item.variantId || !item.url) return this.pendingCustomerProduct(item);
        const cached = this.customerProducts.get(item.variantId);
        if (cached && Date.now() - cached.loadedAt < 30000) return cached.product;
        const originalUrl = new URL(item.url, location.origin);
        const match = originalUrl.pathname.match(/\/products\/([^/]+)$/);
        if (!match) throw new Error('Invalid product URL');
        const root = this.dataset.rootUrl.replace(/\/$/, '') + '/';
        const url = new URL(root + 'products/' + match[1], location.origin);
        url.searchParams.set('view', 'texbrite-reorder');
        url.searchParams.set('variant', item.variantId);
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url, {signal, credentials:'same-origin', cache:'no-store'});
        if (!response.ok) throw new Error('Product unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-qo-products]');
        if (!content) throw new Error('Product data unavailable');
        const product = JSON.parse(content.textContent)[0];
        const variant = product?.variants?.find(option => String(option.id) === String(item.variantId));
        if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0) throw new Error('Variant unavailable');
        const current = {...product, id:String(product.id) + '-' + String(variant.id), variants:[variant]};
        this.customerProducts.set(item.variantId, {loadedAt:Date.now(), product:current});
        return current;
      }
      async renderCustomerProducts() {
        if (!this.customer) return;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const customer = this.customer;
        const query = this.normalizeCustomer(this.searchInput.value);
        const view = this.querySelector('[data-qo-history-view]').value;
        const items = customer.items.filter(item => (view === 'all' || (view === 'pending' ? !item.variantId : Boolean(item.variantId))) && (!query || this.normalizeCustomer([item.title, item.sku, item.size].join(' ')).includes(query)));
        const pageSize = 6;
        const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
        this.customerPage = Math.min(this.customerPage, pageCount - 1);
        const start = this.customerPage * pageSize;
        this.querySelector('[data-qo-heading]').textContent = this.copy.customer_history_title;
        this.querySelector('[data-qo-history-pages]').hidden = items.length <= pageSize;
        this.querySelector('[data-qo-history-range]').textContent = this.message('customer_range', {first:items.length ? start + 1 : 0, last:Math.min(start + pageSize, items.length), count:items.length});
        this.querySelector('[data-qo-history-prev]').disabled = this.customerPage === 0;
        this.querySelector('[data-qo-history-next]').disabled = this.customerPage >= pageCount - 1;
        this.results.replaceChildren();
        if (!items.length) {
          this.results.removeAttribute('aria-busy');
          this.searchStatus.textContent = this.copy.customer_empty;
          return;
        }
        this.results.setAttribute('aria-busy', 'true');
        this.searchStatus.textContent = this.copy.customer_loading_products;
        let failures = 0;
        const products = await Promise.all(items.slice(start, start + pageSize).map(async item => {
          try { return await this.currentCustomerProduct(item, controller.signal); }
          catch (error) { failures++; return this.pendingCustomerProduct(item, true); }
        }));
        if (controller.signal.aborted || this.customer !== customer) return;
        this.renderProducts(products, '');
        this.results.removeAttribute('aria-busy');
        this.searchStatus.textContent = failures ? this.copy.customer_products_error : '';
      }
      message(key, values = {}) {
        let value = this.copy[key] || '';
        Object.entries(values).forEach(([name, replacement]) => { value = value.replaceAll('[' + name + ']', String(replacement)); });
        return value;
      }
      node(tag, className, text) {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      }
      price(cents) { return this.money.format(cents / 100); }
      announce(text) {
        this.feedback.textContent = text;
        this.feedback.hidden = !text;
      }
      validQuantity(quantity, variant) {
        return Number.isSafeInteger(quantity) && quantity >= variant.min && quantity <= (variant.max || 9999) && (quantity - variant.min) % variant.step === 0;
      }
      quantityField(id, variant, quantity, labelText) {
        const wrapper = this.node('div');
        const label = this.node('label', '', this.copy.quantity);
        label.htmlFor = id;
        const input = this.node('input');
        Object.assign(input, {id, type:'number', min:String(variant.min), step:String(variant.step), value:String(quantity), required:true});
        if (variant.max) input.max = String(variant.max);
        input.inputMode = 'numeric';
        input.setAttribute('aria-label', labelText);
        wrapper.append(label, input);
        return {wrapper, input};
      }
      async search() {
        this.controller?.abort();
        if (this.customer) {
          this.customerPage = 0;
          this.renderCustomerProducts();
          return;
        }
        const query = this.searchInput.value.trim();
        if (!query) {
          this.results.removeAttribute('aria-busy');
          this.searchStatus.textContent = '';
          this.querySelector('[data-qo-heading]').textContent = this.copy.popular;
          this.renderProducts(this.initialProducts, '');
          return;
        }
        const controller = new AbortController();
        this.controller = controller;
        this.results.setAttribute('aria-busy', 'true');
        this.searchStatus.textContent = this.copy.loading;
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.search = new URLSearchParams({
          q:query, 'resources[type]':'product', 'resources[limit]':'10',
          'resources[options][fields]':'title,product_type,variants.title,variants.sku',
          'resources[options][unavailable_products]':'last',
          section_id:'texbrite-quick-order-results'
        }).toString();
        try {
          const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
          if (!response.ok) throw new Error('Search failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = html.querySelector('[data-qo-products]');
          if (!data) throw new Error('Missing results');
          const products = JSON.parse(data.textContent);
          if (controller.signal.aborted) return;
          this.renderProducts(products, query);
          this.querySelector('[data-qo-heading]').textContent = this.message('matches', {count:products.length});
          this.searchStatus.textContent = !products.length ? this.copy.no_results : products.length === 10 ? this.copy.refine : '';
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.searchStatus.textContent = this.copy.search_error;
        } finally {
          if (!controller.signal.aborted) this.results.removeAttribute('aria-busy');
        }
      }
      renderProducts(products, query) {
        this.results.replaceChildren();
        products.forEach(product => {
          const card = this.node('article', 'qo__product');
          const imageBox = this.node('div', 'qo__image');
          if (product.image) {
            const image = this.node('img');
            Object.assign(image, {src:product.image, alt:'', loading:'lazy', width:64, height:72});
            imageBox.append(image);
          }
          const info = this.node('div');
          const title = this.node('h3');
          const link = this.node('a', '', product.title);
          link.href = product.url;
          title.append(link);
          info.append(title);
          card.append(imageBox, info);
          if (product.reorderPending) {
            info.append(this.node('p', 'qo__hint', product.historyDetail));
            const pending = this.node('p', 'qo__customer-pending', product.reorderPending);
            const contact = this.node('a', '', this.copy.quote);
            contact.href = this.dataset.contactUrl;
            pending.append(contact);
            card.append(pending);
            this.results.append(card);
            return;
          }
          if (product.quoteOnly || product.optionsOnly) {
            const special = this.node('a', 'qo__special', product.quoteOnly ? this.copy.quote : this.copy.options);
            special.href = product.quoteOnly ? this.dataset.contactUrl : product.url;
            card.append(special);
            this.results.append(card);
            return;
          }
          const variants = product.variants;
          if (!variants.length) return;
          const normalize = value => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          const normalizedQuery = normalize(query);
          let variant = (normalizedQuery ? variants.find(v => normalize(v.sku) === normalizedQuery) : null) || variants.find(v => v.available && v.price > 0) || variants[0];
          const meta = this.node('div', 'qo__meta');
          const sku = this.node('span');
          const price = this.node('span', 'qo__price');
          const amount = this.node('span');
          const packageLabel = this.node('span', 'qo__package');
          price.append(amount, packageLabel);
          meta.append(sku, price);
          info.append(meta);
          const controls = this.node('div', 'qo__controls');
          const sizeWrap = this.node('div');
          const sizeLabel = this.node('label', '', this.copy.size);
          const select = this.node('select');
          select.id = this.id + '-qo-size-' + product.id;
          sizeLabel.htmlFor = select.id;
          select.setAttribute('aria-label', this.copy.size + ' — ' + product.title);
          variants.forEach(v => {
            const title = v.title === 'Default Title' ? v.packageSize || this.copy.standard : v.title;
            const text = title + (v.available ? '' : ' — ' + this.copy.sold_out);
            select.append(new Option(text, String(v.id)));
          });
          select.value = String(variant.id);
          sizeWrap.append(sizeLabel, select);
          const quantity = this.quantityField('qo-quantity-' + product.id, variant, variant.min, this.message('quantity_named', {name:product.title}));
          const add = this.node('button', 'qo__button qo__button--dark', this.copy.add);
          add.type = 'button';
          add.setAttribute('aria-label', this.message('add_named', {name:product.title}));
          const rule = this.node('p', 'qo__rule');
          const refresh = () => {
            sku.textContent = variant.sku ? this.copy.item_number + ' ' + variant.sku : this.copy.no_sku;
            amount.textContent = variant.price > 0 ? this.price(variant.price) + (variant.packageLabel ? '' : ' ' + this.copy.each) : this.copy.quote;
            packageLabel.textContent = variant.packageLabel || '';
            packageLabel.hidden = !variant.packageLabel || variant.price <= 0;
            quantity.input.min = String(variant.min);
            quantity.input.step = String(variant.step);
            if (variant.max) quantity.input.max = String(variant.max);
            else quantity.input.removeAttribute('max');
            quantity.input.value = String(variant.min);
            add.disabled = !variant.available || this.busy || this.cartUncertain;
            quantity.input.disabled = !variant.available || variant.price <= 0;
            add.textContent = !variant.available ? this.copy.sold_out : variant.price <= 0 ? this.copy.quote : this.copy.add;
            rule.hidden = variant.min === 1 && variant.step === 1 && !variant.max;
            rule.textContent = this.message('quantity_rule', {min:variant.min, step:variant.step});
            link.href = product.url.split('?')[0] + '?variant=' + variant.id;
          };
          select.addEventListener('change', () => {
            variant = variants.find(v => String(v.id) === select.value);
            refresh();
          });
          add.addEventListener('click', () => {
            if (this.busy || this.cartUncertain) return;
            if (variant.price <= 0) { location.assign(this.dataset.contactUrl); return; }
            const value = Number(quantity.input.value);
            const existing = this.selection.get(String(variant.id));
            const total = (existing?.quantity || 0) + value;
            if (!this.validQuantity(value, variant) || !this.validQuantity(total, variant)) {
              quantity.input.setCustomValidity(this.copy.invalid_quantity);
              quantity.input.reportValidity();
              return;
            }
            quantity.input.setCustomValidity('');
            if (!existing && this.selection.size >= 50) { this.announce(this.copy.list_full); return; }
            this.selection.set(String(variant.id), {product, variant, quantity:total});
            this.renderList();
            this.announce(this.message('added', {name:product.title}));
          });
          quantity.input.addEventListener('input', () => quantity.input.setCustomValidity(''));
          controls.append(sizeWrap, quantity.wrapper, add);
          card.append(controls, rule);
          refresh();
          this.results.append(card);
        });
      }
      renderList() {
        const list = this.querySelector('[data-qo-selected]');
        list.replaceChildren();
        this.selection.forEach((entry, id) => {
          const {product, variant, quantity} = entry;
          const line = this.node('li', 'qo__line');
          const title = this.node('p', 'qo__line-title', product.title);
          const variantTitle = variant.title === 'Default Title' ? variant.packageSize || this.copy.standard : variant.title;
          const detail = this.node('p', 'qo__line-detail', variantTitle + (variant.sku ? ' · ' + variant.sku : ''));
          const packageDetail = this.node('p', 'qo__line-package', variant.packageLabel ? this.price(variant.price) + ' ' + variant.packageLabel : '');
          packageDetail.hidden = !variant.packageLabel;
          const bottom = this.node('div', 'qo__line-bottom');
          const field = this.quantityField('qo-list-' + id, variant, quantity, this.message('quantity_named', {name:product.title + ' ' + variantTitle}));
          field.wrapper.className = 'qo__line-quantity';
          const priceWrap = this.node('div', 'qo__line-price');
          const linePrice = this.node('span', '', this.price(variant.price * quantity));
          const remove = this.node('button', 'qo__remove', '× ' + this.copy.removed);
          remove.type = 'button';
          remove.setAttribute('aria-label', this.message('remove_named', {name:product.title + ' ' + variantTitle}));
          field.input.addEventListener('input', () => {
            const value = Number(field.input.value);
            field.input.setCustomValidity(this.validQuantity(value, variant) ? '' : this.copy.invalid_quantity);
            if (field.input.validity.valid) {
              entry.quantity = value;
              linePrice.textContent = this.price(variant.price * value);
              this.updateTotals();
            }
          });
          field.input.addEventListener('change', () => {
            if (!field.input.checkValidity()) field.input.reportValidity();
          });
          remove.addEventListener('click', () => {
            const next = line.nextElementSibling?.querySelector('input') || line.previousElementSibling?.querySelector('input');
            const nextId = next?.id;
            this.selection.delete(id);
            this.renderList();
            this.announce('');
            if (nextId) this.querySelector('#' + nextId)?.focus();
            else this.searchInput.focus();
          });
          priceWrap.append(linePrice, remove);
          bottom.append(field.wrapper, priceWrap);
          line.append(title, detail, packageDetail, bottom);
          list.append(line);
        });
        this.updateTotals();
      }
      updateTotals() {
        let count = 0;
        let total = 0;
        this.selection.forEach(entry => { count += entry.quantity; total += entry.quantity * entry.variant.price; });
        this.querySelector('[data-qo-subtotal]').textContent = this.price(total);
        this.querySelector('[data-qo-units]').textContent = count ? this.message('units', {count}) : this.copy.empty;
        this.querySelector('[data-qo-count]').textContent = '(' + count + ')';
        this.querySelector('[data-qo-mobile-total]').textContent = this.price(total);
        this.querySelector('[data-qo-mobile-units]').textContent = this.message('units', {count});
        this.querySelector('[data-qo-mobile]').hidden = count === 0;
        this.cartButton.disabled = count === 0 || this.busy || this.cartUncertain;
      }
      async addToCart() {
        if (this.busy || this.cartUncertain || !this.selection.size) return;
        const inputs = this.querySelectorAll('[data-qo-selected] input');
        for (const input of inputs) { if (!input.reportValidity()) return; }
        this.busy = true;
        this.cartButton.disabled = true;
        this.cartButton.textContent = this.copy.adding;
        this.announce('');
        this.querySelectorAll('[data-qo-selected] input, [data-qo-selected] button').forEach(node => { node.disabled = true; });
        const items = Array.from(this.selection.values(), entry => ({id:entry.variant.id, quantity:entry.quantity}));
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 25000);
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
            credentials:'same-origin', body:JSON.stringify({items}), signal:controller.signal
          });
          const result = await response.json();
          if (!response.ok) {
            const detail = typeof result.description === 'string' ? result.description : '';
            this.announce(this.copy.cart_error + (detail ? ' ' + detail : ''));
            this.cartUncertain = true;
            return;
          }
          this.announce(this.copy.cart_ready);
          this.submitted = true;
          location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.cartUncertain = true;
          this.announce(this.copy.cart_uncertain);
        } finally {
          clearTimeout(timeout);
          if (this.cartUncertain) {
            this.busy = false;
            this.cartButton.textContent = this.cartButtonLabel;
            this.cartButton.disabled = true;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
